// CHANGE v2 §23: data layer reescrito — produtos/estratégias removidos.
// Substituídos por allocations + health + ai-plan.
import { apiClient, APIResponse, extractApiError } from './api';


export const targetEstimateAPI = {
  async get() {
    try {
      const { data } = await apiClient.get('/emergency-fund/target-estimate/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível calcular os alvos sugeridos.'),
      );
    }
  },
};

export const configAPI = {
  async get() {
    try {
      const { data } = await apiClient.get('/emergency-fund/config/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a configuração.'),
      );
    }
  },

  async update(payload) {
    try {
      const { data } = await apiClient.patch('/emergency-fund/config/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a configuração.'),
      );
    }
  },
};

export const allocationsAPI = {
  async getSetup() {
    try {
      const { data } = await apiClient.get('/emergency-fund/allocation-setup/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os ativos para alocação.'),
      );
    }
  },
  async bulkSave(items) {
    try {
      const { data } = await apiClient.post('/emergency-fund/allocations/bulk/', {
        items,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível guardar as alocações.'),
      );
    }
  },
  async list() {
    try {
      const { data } = await apiClient.get('/emergency-fund/allocations/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as alocações.'),
      );
    }
  },
  async create(payload) {
    try {
      const { data } = await apiClient.post(
        '/emergency-fund/allocations/',
        payload,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar a alocação.'),
      );
    }
  },
  async update(id, payload) {
    try {
      const { data } = await apiClient.patch(
        `/emergency-fund/allocations/${id}/`,
        payload,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a alocação.'),
      );
    }
  },
  async remove(id) {
    try {
      await apiClient.delete(`/emergency-fund/allocations/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível eliminar a alocação.'),
      );
    }
  },
};

export const healthAPI = {
  async get() {
    try {
      const { data } = await apiClient.get('/emergency-fund/health/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a saúde do fundo.'),
      );
    }
  },
};

export const buildGoalAPI = {
  async getSuggestion() {
    try {
      const { data } = await apiClient.get('/emergency-fund/build-goal-suggestion/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível obter a sugestão de objectivo.'),
      );
    }
  },
  async create(payload = {}) {
    try {
      const { data } = await apiClient.post(
        '/emergency-fund/create-build-goal/',
        payload,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar o objectivo.'),
      );
    }
  },
};

export const efAlertsAPI = {
  async list() {
    try {
      const { data } = await apiClient.get('/emergency-fund/alerts/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar alertas do fundo.'),
      );
    }
  },
};

export const wizardAPI = {
  async advance(step) {
    try {
      const { data } = await apiClient.post('/emergency-fund/wizard/advance/', {
        step,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível avançar no wizard.'),
      );
    }
  },
};

export const planAPI = {
  async simulate(riskProfile) {
    try {
      const { data } = await apiClient.post(
        '/emergency-fund/plan/simulations/simulate/',
        { risk_profile: riskProfile },
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível simular o plano.'),
      );
    }
  },
  async listSimulations() {
    try {
      const { data } = await apiClient.get('/emergency-fund/plan/simulations/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar simulações.'),
      );
    }
  },
  async toggleFavorite(id) {
    try {
      const { data } = await apiClient.post(
        `/emergency-fund/plan/simulations/${id}/toggle-favorite/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar favorito.'),
      );
    }
  },
};

export const aiPlanAPI = {
  async get(force = false) {
    try {
      const url = force
        ? '/emergency-fund/ai-plan/?force=1'
        : '/emergency-fund/ai-plan/';
      const { data } = await apiClient.get(url);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a dica.'),
      );
    }
  },
  async refresh() {
    try {
      const { data } = await apiClient.post('/emergency-fund/ai-plan/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível gerar nova dica.'),
      );
    }
  },
};
